import { BaseWorkflowDefinition, } from './base-workflow-definition.js';
export class LinkSendingWorkflowDefinition extends BaseWorkflowDefinition {
    constructor() {
        super(...arguments);
        this.id = 'link_sending';
        this.name = 'Link sending';
        this.description = 'Automatically send links via SMS when conditions are met';
        this.allowedActions = ['SMS_SEND'];
        this.actionType = 'IMPLICIT';
        this.category = 'Link sending';
        this.filters = [
            {
                field: 'property.id',
                description: 'Filter by specific property ID',
                required: true,
            },
        ];
    }
}
export const linkSendingDefinition = new LinkSendingWorkflowDefinition();
//# sourceMappingURL=link-sending.js.map